import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import loaderSlice  from './slices/loaderSlice';
import settingsSlice from './slices/settingsSlice';
import projectSlice from './slices/projectSlice';
import networkSlice from "./slices/networkSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    settings: settingsSlice,
    loader: loaderSlice,
    projects: projectSlice,
    network: networkSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
